import { render, staticRenderFns } from "./quests.vue?vue&type=template&id=5505b75c&"
import script from "./quests.vue?vue&type=script&lang=ts&"
export * from "./quests.vue?vue&type=script&lang=ts&"
import style0 from "./quests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports